import CancelIcon from '@mui/icons-material/Cancel';

import { Button, ButtonPropsI } from '@sh4res/bo-common/components/Button';

export function CancelButton({ sx, ...props }: ButtonPropsI) {
  return (
    <Button
      color="error"
      variant="contained"
      data-testid={props['data-testid']}
      {...props}
      sx={[{ height: '30px', fontWeight: 'bold' }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <CancelIcon />
    </Button>
  );
}
